import React from 'react';
import styles from './HoverOptionsMenu.module.scss';
import { Button, CheckBox, BlobContainer } from 'components/common';
import { HoverOptionsMenuProps } from './types';

const HoverOptionsMenu = (props: HoverOptionsMenuProps) => {
  const {
    hide,
    onSelect,
    options,
    checkboxStatuses = null
  } = props;

  return (
    <BlobContainer hide={hide} className={styles.container}>
      {options.map((option, index) =>
        checkboxStatuses
          ? <CheckBox
            key={index}
            checked={checkboxStatuses[option.key]}
            onClick={() => onSelect(option.key)}
            label={option.label}
          />
          : <Button
            key={index}
            onClick={() => onSelect(option.key)}
          >
            {option.label}
          </Button>
      )}
    </BlobContainer>
  );
};

export default HoverOptionsMenu;
